import React from "react";
import { Table } from "react-bootstrap";
import styled, { css } from "styled-components";
import { CreateNFeContext } from "../../../Context";
import { toast } from "react-toastify";
import Text from "../../../../../../../_components/Text";

import * as colors from "../../../../../../../assets/_base/colors";

const TabHeader = styled.th`
  cursor: pointer;
  text-align: center;
  ${(props) => {
    if (props.active) {
      return css`
        background-color: ${colors.darkBlue} !important;
        * {
          color: white !important;
        }
      `;
    }
  }}
`;
const TableData = styled.td`
  cursor: pointer;
  text-align: center;
  ${(props) => {
    if (props.active) {
      return css`
        background-color: ${colors.lightBlue} !important;
        * {
          color: white !important;
        }
      `;
    }
  }}
`;

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  function changeStep(currentStep) {
    context.handlers.changeStep({
      target: { dataset: { issuerHeaderStep: currentStep } },
    });
  }
  return (
    <React.Fragment>
      <div className="d-sm-block d-md-none d-lg-none row">
        <div className="col-12 py-3">
          <select onChange={e => context.handlers.setStep(e.target.value)} className="form-control">
            <option selected={context.step === "nfe-details"} value="nfe-details" className="text-center">
              Passo 1: Detahes da NF-e
            </option>
            <option selected={context.step === "items"} className="text-center" value="items">
              Passo 2: Itens da NF-e
            </option>
            <option selected={context.step === "payments-transport"} className="text-center" value="payments-transport">
              Passo 3: Pagamentos e Frete
            </option>
            <option selected={context.step === "finish"} className="text-center" value="finish">
              Passo 4: Finalizar
            </option>
          </select>
        </div>
      </div>
      <div className="d-none d-lg-block d-md-block row">
        <div className="col-12">
          <Table striped bordered hover>
            <thead>
              <tr>
                <TabHeader
                  data-cy-test="#nfe-issuer-header-navigate-nfe-details"
                  active={context.step === "nfe-details"}
                  onClick={() => changeStep("nfe-details")}
                >
                  <Text>Passo 1</Text>
                </TabHeader>
                <TabHeader
                  data-cy-test="#nfe-issuer-header-navigate-nfe-items"
                  active={context.step === "items"}
                  onClick={() => {
                    context.nfe.identification.recipient ?
                      changeStep("items")
                      :
                      toast.error("Selecione o Destinatário!", { position: "top-center" })
                  }}
                >
                  <Text>Passo 2</Text>
                </TabHeader>
                <TabHeader
                  data-cy-test="#nfe-issuer-header-navigate-nfe-payments-transport"
                  active={context.step === "payments-transport"}
                  onClick={() => {
                    context.nfe.items.length >= 1 ?
                      changeStep("payments-transport")
                      :
                      toast.error("Adicione ao menos um item!", { position: "top-center" })
                  }}
                >
                  <Text>Passo 3</Text>
                </TabHeader>
                <TabHeader
                  data-cy-test="#nfe-issuer-header-navigate-nfe-finish"
                  active={context.step === "finish"}
                  onClick={() => {
                    context.nfe.payments.length >= 1 ?
                      changeStep("finish")
                      :
                      context.nfe.identification.nat_op == "Devolução" || context.nfe.identification.nat_op == "Remessa"  ?
                        changeStep("finish")
                        :
                        toast.error("Adicione ao menos um pagamento!", { position: "top-center" })
                  }}
                >
                  <Text>Passo 4</Text>
                </TabHeader>
              </tr>
            </thead>
            <tbody>
              <tr>
                <TableData active={context.step === "nfe-details"}>
                  <Text>Detalhes da NF-e</Text>
                </TableData>
                <TableData active={context.step === "items"}>
                  <Text>Itens da Nota</Text>
                </TableData>
                <TableData active={context.step === "payments-transport"}>
                  <Text>Pagamentos e Frete</Text>
                </TableData>
                <TableData active={context.step === "finish"}>
                  <Text>Finalizar</Text>
                </TableData>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/components/Steps/Header/index.jsx